import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CallState } from '@lcs/shared/api';
import { Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { LcsDialogService } from 'src/app/common-components/dialog/dialog.service';
import { FormComponent } from 'src/app/common-components/forms-base/form-component.interface';
import { editMailboxPinSubmit } from '../../mailbox-details/state/mailbox-detail.actions';
import { EditMailboxPinViewComponent } from '../views/edit-mailbox-pin-view.component';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    selector: 'ndt-edit-mailbox-pin',
    styleUrls: ['./edit-mailbox-pin.component.scss'],
    templateUrl: './edit-mailbox-pin.component.html',
    standalone: false
})
export class EditMailboxPinComponent implements OnInit, OnDestroy, FormComponent {
   @ViewChild(EditMailboxPinViewComponent) editMailboxPinViewComponent: EditMailboxPinViewComponent;

   callState: Observable<CallState>;

   form: UntypedFormGroup;

   private destroyed$ = new Subject<void>();

   constructor(
      protected store: Store,
      private fb: FormBuilder,
      private dialogService: LcsDialogService,
      public dialogRef: MatDialogRef<EditMailboxPinComponent>,
      @Inject(MAT_DIALOG_DATA) public data: { mailboxId: number }
   ) {}

   ngOnInit(): void {
      this.initializeForm();
   }

   ngOnDestroy(): void {
      this.destroyed$.next();
   }

   initializeForm(): void {
      this.form = this.fb.group({
         mailboxEditPin: this.fb.group(
            {
               password: [null, [Validators.required, Validators.pattern(/^\d{3,10}$/i)]],
               passwordConfirm: [null, Validators.required],
            },
            { validator: this.validPassword }
         ),
      });
   }

   validPassword(control: UntypedFormGroup) {
      const password = control.get('password')?.value;
      const passwordConfirm = control.get('passwordConfirm')?.value;
      if (password !== passwordConfirm) {
         control.get('passwordConfirm')?.setErrors({ validPassword: true });
      } else {
         control.get('passwordConfirm')?.setErrors(null);
      }
   }

   onCloseClick(): void {
      this.dialogService.close();
   }

   onCreate(): void {
      if (this.form.valid) {
         this.store.dispatch(
            editMailboxPinSubmit({
               password: this.form.value.mailboxEditPin.password,
               mailboxId: this.data.mailboxId,
            })
         );
      }
      this.dialogRef.close();
   }
}
